import { useEffect, useMemo, useState } from "react"

import { Flex, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import { formatCurrency, getDates } from "../../../../Utils/utils"
import ReferralActions from "../../reducer"
import ChartModal from "../ChartModal/ChartModal"

import "./styles.less"

const chartTypes = {
  "affiliates-chart": {
    title: "Affiliates",
    dataType: "count"
  },
  "referrals-chart": {
    title: "Referrals",
    dataType: "count"
  },
  "ba-chart": {
    title: "Business accounts",
    dataType: "count"
  },
  "alerts-chart": {
    title: "Alerts",
    dataType: "count"
  },
  "rewarded-chart": {
    title: "Rewarded",
    dataType: "volume"
  }
}

const { Text } = Typography

const AdminStatisticsBlock = () => {
  const dispatch = useDispatch()
  const {
    adminStatisticBlocks,
    adminStatisticBlockChart,
    adminStatisticBlockChartFetching,
    adminStatisticBlocksFetching
  } = useSelector((state) => state.referrals)
  const { testData: test_data } = useSelector((state) => state.globalFilters)
  const [openChart, setOpenChart] = useState()
  const [chartType, setChartType] = useState("affiliates-chart")

  const [period, setPeriod] = useState("7 days")

  const totalValue = useMemo(() => {
    return adminStatisticBlockChart?.result?.daily_total?.reduce((sum, cur) => sum + cur) ?? 0
  }, [adminStatisticBlockChart])

  const formattedChartData = useMemo(() => {
    const dataType = chartTypes?.[chartType]?.dataType
    if (dataType !== "volume") return adminStatisticBlockChart
    if (
      !adminStatisticBlockChart ||
      !adminStatisticBlockChart?.result ||
      !adminStatisticBlockChart?.result?.daily_total
    ) {
      return null
    }
    const resultInDollars =
      adminStatisticBlockChart?.result?.daily_total?.map((value) => value / 100) || []
    return {
      ...adminStatisticBlockChart,
      result: {
        ...adminStatisticBlockChart?.result,
        daily_total: resultInDollars
      }
    }
  }, [adminStatisticBlockChart])

  useEffect(() => {
    const period_query = getDates(period)
    dispatch(
      ReferralActions.getAdminStatisticBlockChartRequest({
        chartType,
        params: {
          ...period_query,
          test_data
        }
      })
    )
  }, [chartType, period, test_data])

  return (
    <Flex className="admin-statistic-block" gap={24}>
      <Flex
        className="block"
        vertical
        gap={4}
        onClick={() => {
          setOpenChart(true)
          setChartType("affiliates-chart")
        }}
      >
        <Text className="text">Affiliates</Text>
        <Text className="value">{adminStatisticBlocks?.affiliates?.toLocaleString()}</Text>
      </Flex>
      <Flex
        className="block"
        vertical
        gap={4}
        onClick={() => {
          setOpenChart(true)
          setChartType("referrals-chart")
        }}
      >
        <Text className="text">Referrals</Text>
        <Text className="value">{adminStatisticBlocks?.referrals?.toLocaleString()}</Text>
      </Flex>
      <Flex
        className="block"
        vertical
        gap={4}
        onClick={() => {
          setOpenChart(true)
          setChartType("ba-chart")
        }}
      >
        <Text className="text">Business accounts</Text>
        <Text className="value">{adminStatisticBlocks?.business_accounts?.toLocaleString()}</Text>
      </Flex>
      <Flex
        className="block"
        vertical
        gap={4}
        onClick={() => {
          setOpenChart(true)
          setChartType("alerts-chart")
        }}
      >
        <Text className="text">Alerts</Text>
        <Text className="value">{adminStatisticBlocks?.alerts?.toLocaleString()}</Text>
      </Flex>
      <Flex
        className="block"
        vertical
        gap={4}
        onClick={() => {
          setOpenChart(true)
          setChartType("rewarded-chart")
        }}
      >
        <Text className="text">Rewarded</Text>
        <Text className="value">{formatCurrency((adminStatisticBlocks?.rewarded ?? 0) / 100)}</Text>
      </Flex>

      <ChartModal
        open={openChart}
        close={() => setOpenChart(false)}
        data={formattedChartData}
        dataType={chartTypes?.[chartType]?.dataType}
        title={chartTypes?.[chartType]?.title}
        loading={adminStatisticBlockChartFetching}
        period={period}
        setPeriod={setPeriod}
        total={totalValue}
      />
    </Flex>
  )
}

export default AdminStatisticsBlock
